import { createContext, useContext } from "react";

export const TabbedTabContext = createContext<
  | {
      tab?: number;
      setTab: (page: number) => void;
    }
  | undefined
>(undefined);

export const useTabbedTabContext = () => {
  const context = useContext(TabbedTabContext);
  if (context === undefined) {
    throw new Error(
      "useTabbedTabContext must be within TabbedTabContextProvider",
    );
  }

  return context;
};
